import { HiBell } from "react-icons/hi2"
import { UnreadDot } from "~/components/unread-dot"
import { SettingsItem } from "~/components/settings-item"
import { useUnreadCount } from "../hooks/use-unread-count"

export const UnreadNotifications = () => {
  const { data: unreadCount } = useUnreadCount()
  return <SettingsItem text="Уведомления" to="/notifications" icon={<HiBell />} right={unreadCount > 0 ? <UnreadDot className="mr-xs" /> : undefined} className="border-t" />
}
